/* eslint-disable no-return-assign */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-shadow */
/* eslint-disable import/first */
/* eslint-disable import/newline-after-import */
/* eslint-disable simple-import-sort/imports */
import { useContext, useState, useCallback, useEffect } from 'react';
import {
  Drawer,
  IconButton,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { AdminTestContext } from '@orientaction/Context';
import { TestService } from '@orientaction/services';
import { getFromLS } from '@orientaction/utils';
interface RecommendedTest {
  id: number;
  title: string;
  description?: string;
  order: number;
}

interface RecommendedTestSearchResult {
  id: number;
  title: string;
  description?: string;
  category_test?: {
    id: number;
    name: string;
  };
}
import style from './style';

// Debounce hook
const useDebounce = (value: string, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const RecommendedTestDrawer = () => {
  const { test, updateTest } = useContext<any>(AdminTestContext);
  const classes = style();
  
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState<RecommendedTestSearchResult[]>([]);
  const [selectedTest, setSelectedTest] = useState<RecommendedTestSearchResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const token = getFromLS('userToken') || '';

  const handleClose = () => {
    updateTest({
      recommendedTestDrawer: {
        ...test.recommendedTestDrawer,
        open: false,
      },
    });
    setSearchQuery('');
    setSearchResults([]);
    setSelectedTest(null);
  };

  const searchTests = useCallback(async (query: string) => {
    if (!query.trim()) {
      setSearchResults([]);
      return;
    }

    setLoading(true);
    try {
      const response = await TestService.getTests(token, undefined, query);
      const tests = response?.data?.data || [];
      
      // Transform Strapi data structure
      const transformedTests = tests.map((test: any) => ({
        id: test.id,
        title: test.attributes.title,
        description: test.attributes.description,
      }));
      
      // Filter out tests that are already selected and the current test
      const alreadySelectedIds = test.recommendedTests?.map((t: RecommendedTest) => t.id) || [];
      const currentTestId = test.test?.id;
      const excludedIds = currentTestId ? [...alreadySelectedIds, currentTestId] : alreadySelectedIds;
      const filteredTests = transformedTests.filter((t: any) => !excludedIds.includes(t.id));
      
      setSearchResults(filteredTests.slice(0, 10)); // Limit to 10 results
    } catch (error) {
      setSearchResults([]);
    } finally {
      setLoading(false);
    }
  }, [token, test.recommendedTests, test.test?.id]);

  useEffect(() => {
    if (debouncedSearchQuery) {
      searchTests(debouncedSearchQuery);
    } else {
      setSearchResults([]);
    }
  }, [debouncedSearchQuery, searchTests]);

  const handleTestSelect = (testResult: RecommendedTestSearchResult) => {
    setSelectedTest(testResult);
    setSearchQuery(testResult.title);
    setSearchResults([]);
  };

  const handleAddTest = () => {
    if (!selectedTest) return;

    const newRecommendedTest: RecommendedTest = {
      id: selectedTest.id,
      title: selectedTest.title,
      description: selectedTest.description,
      order: test.recommendedTests?.length || 0,
    };

    const updatedRecommendedTests = [...(test.recommendedTests || []), newRecommendedTest];

    updateTest({
      recommendedTests: updatedRecommendedTests,
    });

    handleClose();
  };

  const isValidateButtonActive = selectedTest !== null;

  return (
    <Drawer
      anchor="right"
      open={test.recommendedTestDrawer?.open || false}
      classes={{ root: classes.rootStyle, paper: classes.drawerContent }}
    >
      <div className={classes.headerContainer}>
        <IconButton className={classes.closeBtn} onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
        <div className={classes.titleContainer}>
          <Typography variant="h3" className={classes.title}>
            Ajouter un test recommandé
          </Typography>
        </div>
      </div>
      
      <div className={classes.contentChild}>
        <div style={{ width: '100%', maxWidth: '500px' }}>
          <Typography style={{ 
            fontFamily: 'Poppins', 
            fontSize: '16px', 
            fontWeight: 600, 
            color: '#333', 
            marginBottom: '8px',
          }}>
            Ajouter un test
          </Typography>
          
          <div style={{ position: 'relative', marginBottom: '30px' }}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder={isFocused ? "" : "Indiquez le nom ou sélectionnez un test"}
              value={selectedTest ? selectedTest.title : searchQuery}
              onChange={(e) => {
                if (selectedTest) {
                  setSelectedTest(null);
                }
                setSearchQuery(e.target.value);
              }}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              InputProps={{
                endAdornment: loading ? <CircularProgress size={20} /> : null,
                style: { backgroundColor: '#fff' }
              }}
              className={classes.searchInput}
            />
            
            {/* Dropdown des résultats */}
            {searchResults.length > 0 && !selectedTest && (
              <div style={{ 
                position: 'absolute', 
                top: '100%', 
                left: 0, 
                right: 0, 
                backgroundColor: '#fff',
                border: '1px solid #E0E0E0',
                borderTop: 'none',
                borderRadius: '0 0 4px 4px',
                maxHeight: '200px',
                overflowY: 'auto',
                zIndex: 1000,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                {searchResults.map((testResult, index) => (
                  <div
                    key={testResult.id}
                    onClick={() => handleTestSelect(testResult)}
                    style={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#333',
                      borderBottom: index < searchResults.length - 1 ? '1px solid #F5F5F5' : 'none',
                      backgroundColor: '#fff',
                      transition: 'background-color 0.1s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F8F9FF'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                  >
                    {testResult.title?.trim()}
                  </div>
                ))}
              </div>
            )}
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              onClick={handleAddTest}
              disabled={!isValidateButtonActive}
              className={classes.btnPrimary}
            >
              Valider et ajouter ce test recommandé
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default RecommendedTestDrawer; 